module.exports = __webpack_public_path__ + "static/media/IMG_0436.6f8d49ef.jpg";